import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { Router } from '@angular/router';
import { HandlerService } from '../handler.service';
import { AuthService } from '../auth.service';
import { AppComponent } from '../app.component';
import { DomSanitizer } from '@angular/platform-browser';
import { Platform } from '@ionic/angular';

@Component({
  selector: 'app-approval-details',
  templateUrl: './approval-details.component.html',
  styleUrls: ['./approval-details.component.scss'],
})
export class ApprovalDetailsComponent {

  loader: boolean = true;
  getData;
  url;
  id1;
  id;
  name;mob;
  housenbr;
  street;
  city;
  region;
  idproof;
  adsproof;
  state;
  zipcode;
  img;
  img1;
  proofObj:any=[];
  addsProof:any=[];

  constructor(public service: ApiService,
    public router: Router,
    public handler: HandlerService,
    public auth: AuthService,
    public app: AppComponent,
     public santinzer: DomSanitizer,
      public platform: Platform) { }

 ionViewWillEnter(){
  this.url = window.location.href;
  this.id = this.url.split('/').pop();
  this.getuser();
 }

 getuser(){
   this.service.getAddressById( this.id ).subscribe(res=>{
    this.getData = res;
      this.name= this.getData.firstName;
      this.mob=this.getData.contactNbrMob.slice(3);
      this.id1 = this.getData.roles[0]?.roleId;
      
      if(this.getData.userIdProof[0]){
        if(this.getData.userIdProof[0].img){
          this.img = this.getData.userIdProof[0].img;
        }  
      }
      if(this.getData.userAddressProof[0]){
        if(this.getData.userAddressProof[0].img){
          this.img1 = this.getData.userAddressProof[0].img;
        }
      }
      if(this.getData.addresses[0]){
        this.region = this.getData.addresses[0].regionId;
      this.state = this.getData.addresses[0].stateId;
      this.zipcode = this.getData.addresses[0].zipcode;
      }
      setTimeout(() => {
        this.idProof();
        this.AddressProof();
        this.loader=false;
      }, 1000);
   })
 }

 idProof(){
  this.service.getIdProof().subscribe(res => { 
    this.proofObj = res;
    if(this.getData.userIdProof[0]){
      this.proofObj.map(res => {
        if (res.id == this.getData.userIdProof[0].proofId) {
        this.idproof = res.name;
        }
      })
    }
  })
}

AddressProof(){
  this.service.getAddressProof().subscribe(res => { 
    this.addsProof = res;
    if(this.getData.userAddressProof[0]){
      this.addsProof.map(res => {
        if (res.id == this.getData.userAddressProof[0].proofId) {
        this.adsproof = res.name;
        }
      })
   }
  })
}

 approval(){
   this.service.vendorApproval(this.id,this.id1).subscribe(res=>{
    this.router.navigate(['/vendor-approval']);
   })
 }

 reject(){
  this.service.vendorReject(this.id,this.id1).subscribe(res=>{
    this.router.navigate(['/vendor-approval']);
   })
 }

}
